import * as IngredientService from '../services/ingredient.service'

export const getIngredients = (pageToRequest = 1) => (dispatch) => {
    return IngredientService.fetchIngredients(pageToRequest).then((data) => {
        console.warn('fetchIngredients', data)

        dispatch({
          type: 'FETCH_INGREDIENTS_SUCCESS',
          payload: { ingredients: data },
        });
        return Promise.resolve()
      },
      (error) => {
        dispatch({
          type: 'FETCH_INGREDIENTSFAIL',
          message: error
        });
      
        return Promise.reject()
      })
}

export const searchIngredients = (pageToRequest, searchIngredients) => (dispatch) => {
  return IngredientService.searchIngredients(pageToRequest, searchIngredients).then((data) => {
      dispatch({
        type: 'FETCH_INGREDIENTS_SUCCESS',
        payload: { ingredients: data },
      });
      return Promise.resolve()
    },
    (error) => {
      dispatch({
        type: 'FETCH_INGREDIENTS_FAIL',
        message: error
      });
    
      return Promise.reject()
    })
}
